'use client';

import { CustomDataTable } from '@/components/common';
import { type QualityAssuranceProcedure } from '@/domain/qualityAssurance/types';
import { Tooltip } from '@andritzot/metris-web-ui/data-display/tooltip';
import { IconButton } from '@andritzot/metris-web-ui/inputs/icon-button';
import OpenInFullOutlined from '@mui/icons-material/OpenInFullOutlined';
import { Column } from 'primereact/column';
import { useState } from 'react';

import ProcedureDetailDialog from './ProcedureDetailDialog';

type ProcedureDataTableProps = {
  procedures: QualityAssuranceProcedure[];
};

const ProcedureDataTable = ({ procedures }: ProcedureDataTableProps) => {
  const [selectedProcedure, setSelectedProcedure] = useState<QualityAssuranceProcedure | undefined>(undefined);

  const openDetail = (rowData: QualityAssuranceProcedure) => {
    setSelectedProcedure(rowData);
  };

  const closeDetail = () => {
    setSelectedProcedure(undefined);
  };

  const detailButtonTemplate = (rowData: QualityAssuranceProcedure) => (
    <Tooltip title="Details">
      <IconButton
        variant="outlined"
        color="success"
        onClick={() => {
          openDetail(rowData);
        }}
      >
        <OpenInFullOutlined />
      </IconButton>
    </Tooltip>
  );

  return (
    <>
      <CustomDataTable value={procedures} dataKey="idQualityAssuranceProcedure" rows={10}>
        <Column
          headerStyle={{ width: '4rem' }}
          bodyStyle={{ padding: 0, textAlign: 'center' }}
          style={{ padding: 0 }}
          body={detailButtonTemplate}
        />
        <Column field="name" header="Name" sortable />
      </CustomDataTable>
      {selectedProcedure && <ProcedureDetailDialog selectedProcedure={selectedProcedure} onClose={closeDetail} />}
    </>
  );
};

export default ProcedureDataTable;
